import { render, staticRenderFns } from "./clientprofile.vue?vue&type=template&id=488c2d88&scoped=true"
import script from "./clientprofile.vue?vue&type=script&lang=js"
export * from "./clientprofile.vue?vue&type=script&lang=js"
import style0 from "./clientprofile.vue?vue&type=style&index=0&id=488c2d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c2d88",
  null
  
)

export default component.exports